export function fixArticleUrl(url:string) {
  if(!url) {return '';}
  let result = url;
  if(typeof url === "string" && url.indexOf('www.sohu.com') === -1 && url.indexOf('/a/') !== -1 ) {
    result = `//www.sohu.com${url}`;
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/urlUtils.ts